import { LayerProps } from "react-map-gl/maplibre";
import { PolygonSimpleConfigs } from "~map-style-utils/types/__generated/gql/graphql";

export const getPolygonSimpleStyles = ({
	symbolStyle,
}: PolygonSimpleConfigs): LayerProps[] => {
	const styles: LayerProps[] = [];
	// Fill
	if (symbolStyle?.fill?.style === "solid") {
		styles.push({
			id: "solid-fill-filling",
			type: "fill",
			paint: {
				"fill-color": symbolStyle?.fill?.color ?? "#000000",
				"fill-opacity": symbolStyle?.fill?.opacity ?? 0,
			},
		});
	} else if (symbolStyle?.fill?.style !== "none") {
		styles.push({
			id: "pattern-fill-filling",
			type: "fill",
			paint: {
				"fill-pattern": `${symbolStyle?.fill?.style}-pattern-${symbolStyle?.fill?.color}`,
				"fill-opacity": symbolStyle?.fill?.opacity ?? 0,
			},
		});
	}

	// Stroke
	if (symbolStyle?.stroke?.style === "solid") {
		styles.push({
			id: "solid-stroke-casing",
			type: "line",
			layout: {
				"line-cap": "round",
				"line-join": "round",
			},
			paint: {
				"line-color": symbolStyle?.stroke?.color ?? "#000000",
				"line-width": symbolStyle?.stroke?.width ?? 0,
				"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
			},
		});
	}
	if (symbolStyle?.stroke?.style === "dash") {
		styles.push({
			id: "dash-stroke-casing",
			type: "line",
			layout: {
				"line-join": "round",
				"line-cap": "round",
			},
			paint: {
				"line-color": symbolStyle?.stroke?.color ?? "#000000",
				"line-width": symbolStyle?.stroke?.width ?? 1,
				"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
				"line-dasharray": [2, 2],
			},
		});
	}

	if (symbolStyle?.stroke?.style === "dot") {
		styles.push({
			id: "dot-stroke-casing",
			type: "line",
			layout: {
				"line-join": "round",
				"line-cap": "round",
			},
			paint: {
				"line-color": symbolStyle?.stroke?.color ?? "#000000",
				"line-width": symbolStyle?.stroke?.width ?? 1,
				"line-dasharray": [0.5, 2],
			},
		});
	}

	return styles;
};
